<div
  class="message-container text-center px-2 cbsw-success-booking-step"
  role="region"
  [attr.aria-label]="'Booking confirmation'"
  [attr.aria-live]="'polite'"
>
  <div
    class="mb-1 cbsw-success-booking-message"
    role="group"
    [attr.aria-label]="'Success message'"
  >
    <app-csw-text
      [text]="successTitleTemplate | translation: 'template_content': lang"
      customClass="fw-600"
      role="heading"
      aria-level="2"
    />
  </div>

  <div
    class="cbsw-success-booking-sub-message"
    role="group"
    [attr.aria-label]="'Additional information'"
  >
    <app-csw-text
      [text]="successTemplate | translation: 'template_content': lang"
      role="text"
    />
  </div>

  @if (showAppointmentLink() && manageBookingTemplate && appointments.length > 0) {
    <div
      class="mt-4 cbsw-success-booking-appointment-links"
      role="group"
      [attr.aria-label]="manageBookingTemplate | translation: 'template_content': lang"
    >
      @if (appointments.length === 1) {
        <a
          class="cbsw-success-booking-appointment-link"
          [href]="appointmentLink(appointments[0].uuid)"
          target="_blank"
          rel="noopener"
          [attr.aria-label]="manageBookingTemplate | translation: 'template_content': lang"
        >{{ manageBookingTemplate | translation: 'template_content': lang }}</a>
      } @else {
        <span class="cbsw-success-booking-links-label">
          {{ manageBookingTemplate | translation: 'template_content': lang }}:
        </span>
        @for (appointment of appointments; track appointment.uuid; let i = $index; let last = $last) {
          <a
            class="cbsw-success-booking-appointment-link"
            [href]="appointmentLink(appointment.uuid)"
            target="_blank"
            rel="noopener"
            [attr.aria-label]="('booking_components.appointment' | translate) + ' ' + (i + 1)"
          >{{ ('booking_components.appointment' | translate) + ' ' + (i + 1) + (last ? '' : ',') }}</a>
        }
      }
    </div>
  }

  @if (showIcsDownload() && downloadIcsTemplate && appointments.length > 0) {
    <div
      class="mt-2 cbsw-success-booking-ics-links"
      role="group"
      [attr.aria-label]="downloadIcsTemplate | translation: 'template_content': lang"
    >
      @if (appointments.length === 1) {
        @if (isDownloadingIcs(appointments[0].uuid)) {
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            [attr.aria-label]="downloadIcsTemplate | translation: 'template_content': lang"
          ></span>
        } @else {
          <a
            class="cbsw-success-booking-ics-link"
            href="javascript:void(0)"
            (click)="downloadIcs(appointments[0].uuid)"
            [attr.aria-label]="downloadIcsTemplate | translation: 'template_content': lang"
          >{{ downloadIcsTemplate | translation: 'template_content': lang }}</a>
        }
      } @else {
        <span class="cbsw-success-booking-links-label">
          {{ downloadIcsTemplate | translation: 'template_content': lang }}:
        </span>
        @for (appointment of appointments; track appointment.uuid; let i = $index; let last = $last) {
          @if (isDownloadingIcs(appointment.uuid)) {
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              [attr.aria-label]="(downloadIcsTemplate | translation: 'template_content': lang) + ' ' + ('booking_components.appointment' | translate) + ' ' + (i + 1)"
            ></span>
          } @else {
            <a
              class="cbsw-success-booking-ics-link"
              href="javascript:void(0)"
              (click)="downloadIcs(appointment.uuid)"
              [attr.aria-label]="(downloadIcsTemplate | translation: 'template_content': lang) + ' ' + ('booking_components.appointment' | translate) + ' ' + (i + 1)"
            >{{ ('booking_components.appointment' | translate) + ' ' + (i + 1) + (last ? '' : ',') }}</a>
          }
        }
      }
    </div>
  }

  <div
    class="mt-4 cbsw-success-booking-next-buttons-section"
    role="group"
    [attr.aria-label]="'Next booking action'"
  >
    <app-button
      id="{{ 'booking-success-view-book-next-btn' }}"
      (clickEvent)="onAdditionalBooking()"
      [fontColor]="widgetService?.widgetConf?.button_font_color"
      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      role="button"
      [attr.aria-label]="'Book another appointment'"
      tabindex="0"
    >
      {{ 'booking_components.bookNextAppointment' | translate }}
    </app-button>
  </div>

  @if (
    bookingService.redirectAfterBookingEnabled &&
    bookingService.successfulBookingRedirectUrl &&
    bookingService.redirectAfterBookingAction === bookingRedirectionViews.BOOKING_SUCCESS_VIEW
  ) {
    <div
      class="mt-4 cbsw-success-booking-next-redirection-section"
      role="group"
      [attr.aria-label]="'Redirection action'"
    >
      <app-button
        id="{{ 'booking-success-view-book-redirection-btn' }}"
        (clickEvent)="redirectTo()"
        [fontColor]="widgetService?.widgetConf?.button_font_color"
        [backgroundColor]="widgetService?.widgetConf?.button_background_color"
        role="button"
        [attr.aria-label]="(redirectionButtonTemplate | translation: 'template_content': lang) + ' - External link'"
        tabindex="0"
      >
        {{ redirectionButtonTemplate | translation: 'template_content': lang }}
      </app-button>
    </div>
  }
</div>
